import type { SharedProps } from '@bonniernews/dn-design-system-web/assets/types/shared-props.ts'

import { formatClassString } from '@bonniernews/dn-design-system-web/helpers/formatClassString.ts'

export interface SpinnerProps extends SharedProps {
  variant: 'brand' | 'secondary' | 'primary' | 'onBrand' | 'onBusiness' | 'staticBlack' | 'staticWhite'
  size?: 'large' | 'small' | 'xsmall'
  forcePx?: boolean
}

/**
 * - GitHub: [BonnierNews/dn-design-system/web/src/components/spinner](https://github.com/BonnierNews/dn-design-system/tree/main/web/src/components/spinner)
 * - Storybook: [Spinner](https://designsystem.dn.se/?path=/docs/basic-spinner--docs)
 *
 * The component will not include styling by itself. Make sure to include the right styles for the component. See example below:
 * `@use '@bonniernews/dn-design-system-web/components/spinner/spinner.scss'`
 */
export const Spinner = ({ variant = 'primary', size = 'large', forcePx, classNames, attributes }: SpinnerProps) => {
  const componentClassName = 'ds-spinner'

  const classes = formatClassString([
    `${componentClassName}`,
    `${componentClassName}--${variant}`,
    `${componentClassName}--${size}`,
    forcePx && 'ds-force-px',
    classNames,
  ])

  return (
    <span className={classes} {...attributes}>
      <span className={`${componentClassName}__inner`}></span>
    </span>
  )
}

export default Spinner
